import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { InsectaServiceBase } from './insecta.base.service';
import { IEppoCode } from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class EppoCodeService extends InsectaServiceBase {
  public getEppoCode(scientificName: string): Observable<IEppoCode> {
    return this.get<IEppoCode>(`/eppo/${scientificName}`, `v1`);
  }
}
